import { render, staticRenderFns } from "./Convivencia.vue?vue&type=template&id=40e2bc5c"
import script from "./Convivencia.vue?vue&type=script&lang=js"
export * from "./Convivencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports